import { db } from 'Compass/profile-lab/services/db';

export const getUserLid = async (): Promise<number> => {
  const config = await db.getSubjectConfig();
  const userLid = parseInt(config.userLid, 10);
  if (!userLid) {
    throw new Error('No user selected. Please select a user first.');
  }
  return userLid;
};

export const getUserLidOrNull = async (): Promise<number | null> => {
  const config = await db.getSubjectConfig();
  const userLid = parseInt(config.userLid, 10);
  return userLid || null;
};
